module.exports = __webpack_public_path__ + "img/RozaShekhani.18fb5fb1.jpg";